"use client";
import { useEffect } from "react";
import { colors } from "./Colors";

const Theme = () => {
  useEffect(() => {
    loadTheme();
  }, []);

  const loadTheme = async () => {
    try {
      const root = document.documentElement;
      Object.keys(colors).forEach((key) => {
        root.style.setProperty(key, colors[key]);
      });
    } catch (error) {
      // console.error("Error loading theme:", error);
    }
  };

  return null;
};

export default Theme;
